{
  "notFound": {
    "message": "No matter how bright I shine, maybe the bulb broke, but this page is not here ...",
    "goToDashboard": "I'll go to the Dashboard instead"
  }
}
